import { Component } from '@angular/core';

/**
 * Screen shown when a guest link points at a document that is no longer available.
 *
 * A sent document reaches this state by three routes — the sender cancelled it, sent it back to
 * the project with "enviar a proyecto", or moved it to another flow — and the guest path cannot
 * tell them apart: all three arrive as `draft` with a perfectly valid token. So the copy claims
 * none of them. It says the document is no longer available and nothing more (D-10).
 *
 * It must say neither "cancelled" nor "expired": "cancelled" would mislabel the two routes that
 * are not a cancellation, and "expired" is the mislabel this feature exists to remove — until
 * now this case was reported as `DocumentExpired` and landed on `/expired` (FR-009, FR-010).
 *
 * Structurally modeled on the existing `/expired` screen, so the two read as one family (D-03).
 */
@Component({
  selector: 'literax-unavailable',
  templateUrl: './unavailable.component.html',
  styleUrls: ['./unavailable.component.scss'],
})
export class UnavailableComponent {}
